const configuredBaseUrl = process.env.REACT_APP_API_BASE_URL;
const legacyServer = process.env.REACT_APP_API_SERVER_IP;
const defaultApiRoot = process.env.NODE_ENV === 'production'
  ? window.location.origin
  : 'http://localhost:7077';

export const API_ROOT = (
  configuredBaseUrl || (legacyServer ? `https://${legacyServer}` : defaultApiRoot)
).replace(/\/$/, '');

export const API_BASE_URL = `${API_ROOT}/v1`;
export const API_BASE_URL_V2 = `${API_ROOT}/v2`;
